module.exports = __webpack_public_path__ + "static/media/C1.1cb2b405.webp";